// AY swaps `push` on both queues once it loads, so a push after load still runs.

export function ensureAyManagerEnv(): void {
  if (!window.ayManagerEnv) {
    Reflect.set(window, 'ayManagerEnv', { cmd: [] })
  }
}

/** Run once the AY analytics SDK is up. */
export function whenAyReady(fn: () => void): void {
  window.assertiveQueue = window.assertiveQueue || []
  window.assertiveQueue.push(fn)
}

/** Run inside the AY yield manager's command queue. */
export function withAyManager(fn: () => void): void {
  ensureAyManagerEnv()
  window.ayManagerEnv?.cmd.push(fn)
}
